import React from 'react';
import { noop } from 'lodash';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

// DEPRECATED: use src/components/dialog/ConfirmationDialog.component.jsx

// eslint-disable-next-line react/prefer-stateless-function
class SimpleDialog extends React.Component {
  static defaultProps = {
    children: [],
    onLeft: noop,
    onRight: noop,
    onCancel: noop,
  };

  render() {
    const { title, leftButtonText, onLeft, rightButtonText, onRight, onCancel } = this.props;
    const { displayHeader, children, uniqueClass, tag } = this.props;

    const t = fromAnyToTrimmed(tag);

    return (
      <div data-bem="SimpleDialog" data-modal-tag={t} data-dialog-body="SimpleDialog" className={`dialog-container no-show ${fromAnyToTrimmed(uniqueClass)}`}>
        <div data-modal-tag={t} className={`dialog ${fromAnyToTrimmed(displayHeader)}`}>
          <div data-modal-tag={t} className="dialog-header">
            <h2 data-modal-tag={t}>{title}</h2>
            <div data-modal-tag={t} className="close" role="button" tabIndex={0} onClick={onCancel} />
          </div>
          <div data-modal-tag={t} className="body">
            {children}
          </div>
          <div data-modal-tag={t} className="dialog-footer cfix">
            <div data-modal-tag={t} data-cy="confirm-left-button" className="btn btn-white" role="button" tabIndex={0} onClick={onLeft}>
              {leftButtonText}
            </div>
            {rightButtonText !== '' && (
              <div data-modal-tag={t} data-cy="confirm-right-button" className="btn btn-violet" role="button" tabIndex={0} onClick={onRight}>
                {rightButtonText}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SimpleDialog;
